/**
 * W5 AI 补足契约类型(backend AugmentTaskDto 镜像)。
 * 放 shared/api 不放 shared/ui:entities 服务要引用,API DTO 不该耦合 UI 模块(FSD;codex P2)。
 */

export interface AugmentAsset {
  assetId: number;
  seq: number;
  status: string;
  slot?: string | null;
  label?: string | null;
  url?: string | null;
}

export interface AugmentTask {
  taskId: number;
  status: string;
  requestedCount: number;
  mode?: string | null;
  assets: AugmentAsset[];
  /** 起单时刻 ISO-8601。历史任务列表按它认单 —— 只给 taskId 用户认不出哪条是哪条。 */
  createdAt?: string | null;
}

export interface AugmentPick {
  assetId: number;
  slot: string;
  label?: string | null;
}

// BLOCKED 也是终态(治理门拦下;codex P1:漏了它轮询永不停,UI 卡「生成中」)
export const AUGMENT_TERMINAL = new Set(["SUCCESS", "PARTIAL", "FAILED", "CANCELLED", "BLOCKED"]);

/** 任务是否已到终态(面板轮询与产品侧「生成中」角标同一张表)。 */
export function isAugmentTerminal(status?: string | null): boolean {
  return status != null && AUGMENT_TERMINAL.has(status);
}
